interface LocalStorageItem {
    key: string;
    value: any;
}

export default class LocalStorage {
    private readonly localStorage = window.localStorage;

    public setItems(items: LocalStorageItem[]) {
        for (const item of items) {
            this.localStorage.setItem(item.key, item.value);
        }
    }

    public setItemsFromObject(object: any): void {
        const items = Object.keys(object).map((dataKey: any) => {
            const dataObject = {
              key: dataKey,
              value: object[dataKey]
            };
      
            return dataObject;
          });

        this.setItems(items);
    }

    public setItem(key: string, value: string) {
        this.localStorage.setItem(key, value);
    }

    public getItems(keys: string[]): any {
        const localStorageStoredObjects: any = {};

        for (const key of keys) {
            localStorageStoredObjects[key] = this.localStorage.getItem(key);
        }
        return localStorageStoredObjects;
    }

    public getItem(key: string): any {
        return this.localStorage.getItem(key);
    }
}